<script>
  import { templates } from '../stores.js';
  import { navigate } from 'svelte-routing';
  import { init } from '../services/users';
  
  import Header from '../components/Header.svelte';
  import EventCreateProcess from '../components/EventCreateProcess.svelte';

  let eventName = '';

  async function refresh() {
    await init();
  }
</script>

<style>
  .form { padding: 50px 10px;}
</style>

<Header text="create event" />

<EventCreateProcess />

<div class="form" use:refresh>
  <div class="field">
    <label class="label">Event name:</label>
    <p class="control has-icons-left">
      <input class="input" type="text" placeholder="event name" bind:value={eventName}>
      <span class="icon is-small is-left">
        <i class="fas fa-file-video"></i>
      </span>
    </p>
    <span class="has-text-danger" class:is-invisible={eventName.length === 0 || eventName.match(/^[a-zA-Z0-9-:_!()\s\u00df\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00e8\u00e9]+$/)}>Only A-Z, a-z, èéäüöß, 0-9, '-', '_', '!', '?', '(', ')', ':' and spaces are allowed.</span>
  </div>
  <div class="field">
    <p class="control has-text-centered">
      <button class="button is-primary" disabled={!eventName.match(/^[a-zA-Z0-9-:_!()\s\u00df\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00e8\u00e9]+$/)} on:click={() => navigate(`/events/${eventName}/channels`)}>
        NEXT
      </button>
    </p>
  </div>
</div>
